import * as Sentry from '@sentry/nuxt'

const config = useRuntimeConfig().public
const mode = config.mode as string

Sentry.init({
   dsn: config.sentryDsn as string,
   enabled: mode !== 'development',
   environment: mode,
   sendDefaultPii: false,
   tracesSampleRate: mode === 'production' ? 0.2 : 1,
})
